export default "__VITE_ASSET__6MTdm4rp__"